import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { StringSmall } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';

import flashPng from '/img/icons/flash.png';
import flashWebp from '/img/icons/flash.webp';

interface FullRechargeProps {
  className?: string;
}

const FullRecharge: FC<FullRechargeProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'h-10 rounded-[80px] bg-white/10 backdrop-blur-lg flex items-center gap-2 pr-4',
        className,
      )}
    >
      <div className="w-10 h-10 shrink-0 rounded-full flex items-center justify-center bg-white/10">
        <Picture
          className="w-7 h-7 shink-0"
          img={flashPng}
          webp={flashWebp}
          alt="flash"
        />
      </div>
      <StringSmall weight="bold" className="!text-gold">
        {t('Full Recharge')}
      </StringSmall>
    </div>
  );
};

export { FullRecharge };
